import { Typography as AntTypography } from "antd";
import React from "react";

const { Title, Text, Paragraph, ...rest } = AntTypography;

const Typography = { Title, Text, Paragraph, ...rest };

export default Typography;